import React from 'react';
import { IconStroke, IconProps } from './IconTemplate';

import { ReactComponent as Icon } from '@assets/icons/radio-unchecked.svg';

export default function RadioUncheckedIcon(props: IconProps) {
  return <IconStroke icon={Icon} {...props} />;
}
